import React from "react";
import {
  ContentCard,
  SectionHeader,
} from "./landing/landing-ui";

const industries = [
  {
    id: 1,
    title: "Marina and ports",
    description:
      "Berth allocation, scheduling support, vessel data handling, and day-to-day operational coordination where timing and context matter.",
    href: "/solutions/ai-solutions-for-marina-management",
  },
  {
    id: 2,
    title: "Logistics",
    description:
      "Shipment intelligence, document automation, demand signals, and operational visibility across carriers, warehouses, and partners.",
    href: "/solutions/ai-solutions-for-logistics-operations",
  },
  {
    id: 3,
    title: "Aviation",
    description:
      "Planning support, knowledge retrieval, documentation automation, and decision aids for teams that cannot afford guesswork.",
    href: "/solutions/enterprise-ai-chatbot-development",
  },
  {
    id: 4,
    title: "Enterprise operations",
    description:
      "Internal assistants that surface policies, automate handoffs, and reduce repetitive work across departments.",
    href: "/solutions/ai-knowledge-assistants-for-organizations",
  },
  {
    id: 5,
    title: "Supply chain",
    description:
      "Forecasting support, inventory signals, and clearer visibility across suppliers and fulfillment.",
    href: "/solutions/ai-data-intelligence-platforms-for-businesses",
  },
];

function Industries() {
  return (
    <section
      className="landing-section"
      style={{
        background:
          "radial-gradient(circle at top center, #dceae7 -20%, #f3f7f6 65%)",
      }}
    >
      <div className="container max-w-7xl">
        <SectionHeader
          title="Built for operational domains"
          lead="We design around the work that already exists: documents, systems, handoffs, and the people who own them."
        />

        <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {industries.map((industry, index) => (
            <ContentCard
              key={industry.id}
              title={industry.title}
              description={industry.description}
              href={industry.href}
              cta="Explore solution"
              className={index === 0 ? "lg:col-span-2" : ""}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Industries;
